import { resources } from "@constants/hardcoded-strings";
import { LANGUAGE_SELECT_OPTIONS } from "@constants/language-select-options";
import { SelectFormGroup } from "@containers/common/select-form-group/select-form-group";
import { LabelWidthTypes } from "@enums/label-width-types";
import { LocaleTypes } from "@iddataweb/idw-common-ui/enums";
import { SelectOption } from "@idw-types/common";
import styles from "./language-selector-container.less";
import { useMemo } from "react";
import { LanguageSelectorContainerTypes } from "@enums/language-selector-container-types";

type LanguageSelectorContainerProps = {
    idPrefix: string;
    availableLanguages: Array<LocaleTypes>;
    selectedLanguage: LocaleTypes;
    languageSelectorContainerType: LanguageSelectorContainerTypes;
    setSelectedLanguage: (selectedLanguage: LocaleTypes) => void;
}

export const LanguageSelectorContainer = (props: LanguageSelectorContainerProps) => {
    const { idPrefix, availableLanguages, languageSelectorContainerType, selectedLanguage, setSelectedLanguage } = props;
    const availableLanguageSelectOptions = LANGUAGE_SELECT_OPTIONS.filter(lso => {
        return availableLanguages.includes(lso.value);
    });

    const onChangeSelectedLanguage = (newOption: SelectOption<LocaleTypes>) => {
        if (newOption) {
            setSelectedLanguage(newOption.value);
        }
    };

    const selectedLanguageOption = useMemo(() => {
        return LANGUAGE_SELECT_OPTIONS.find(lso => lso.value === selectedLanguage);
    }, [selectedLanguage]);

    return (
        <SelectFormGroup
            className={languageSelectorContainerType === LanguageSelectorContainerTypes.WORKFLOW_MODAL
                ? styles.languageSelectWorkflow
                : styles.languageSelectVerificationLink}
            ariaLabel={resources.pages.verificationServiceDetails.inputs.language.label}
            label={resources.pages.verificationServiceDetails.inputs.language.label}
            afterLabelTooltipText={resources.pages.verificationServiceDetails.inputs.language.tooltip}
            afterLabelTooltipTextPosition={"bottom"}
            automationId={`${idPrefix}-language-input`}
            controlId={`${idPrefix}-language-input`}
            disabled={false}
            isClearable={false}
            isRequired={false}
            isSearchable={true}
            labelWidth={LabelWidthTypes.EXTRA_SMALL}
            options={availableLanguageSelectOptions}
            onChange={onChangeSelectedLanguage}
            selectedOption={selectedLanguageOption}
        />
    );
}